import React from 'react';
import {Animated, StyleSheet, StyleProp, ViewStyle} from 'react-native';

type SkeletonBarProps = {
  width: number | string;
  height: number;
  color?: string;
  borderRadius?: number;
  style?: StyleProp<ViewStyle>;
};

const SkeletonBar: React.FC<SkeletonBarProps> = ({
  width,
  height,
  color = 'rgba(77,63,55,0.10)',
  borderRadius = 6,
  style,
}) => {
  const anim = React.useRef(new Animated.Value(0.4)).current;

  React.useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(anim, {
          toValue: 1,
          duration: 700,
          useNativeDriver: true,
        }),
        Animated.timing(anim, {
          toValue: 0.4,
          duration: 700,
          useNativeDriver: true,
        }),
      ]),
    ).start();
  }, [anim]);

  return (
    <Animated.View
      style={[
        styles.base,
        {width, height, backgroundColor: color, borderRadius, opacity: anim},
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  base: {},
});

export default SkeletonBar;
